<template>
	<div class="default-page vertical-align-center">
		<b-container>
			<b-row>
				<b-col md="3" class="text-center">
					<div class="avatar">
						<Avatar :avatar="avatarCatNotebook" />
					</div>
				</b-col>
				<b-col md="6" offset-md="1">
					<h1>Passwort zurücksetzen</h1>
					<p>Setz dir ein neues sicheres Passwort:</p>
					<Password v-model="password"/>
					<div class="mt-4">
						<Button
							text="Passwort zurücksetzen"
							:disabled="!passwordValid || resetting"
							:loading="resetting"
							icon="checkmark"
							@click="reset"
						/>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Password from "@/vue/common/form/Password";
import Button from "@/vue/common/Button";
import {isDefined} from "@/helper/Value";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import Reset from "@/api/auth/password/Reset";
import {getQueryParams} from "@/helper/Url";
import Avatar, {CAT_NOTEBOOK} from "@/vue/common/image/Avatar.vue";

export default {
	components: {
		Avatar,
		Button,
		Password
	},

	data ()
	{
		return {
			password: undefined,
			resetting: false,
		};
	},

	computed: {
		passwordValid ()
		{
			return isDefined(this.password);
		},
		avatarCatNotebook ()
		{
			return CAT_NOTEBOOK;
		}
	},

	methods: {
		async reset ()
		{
			this.resetting = true;

			const queryParams = getQueryParams();

			try
			{
				await new Reset()
					.setPassword(this.password)
					.setId(queryParams.id)
					.setHash(queryParams.hash)
					.call();

				location.href = '/auth/login?postPasswordReset=1';
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.resetting = false;
		}
	}
}
</script>
